/**
 * Helper para registrar tags de Background Sync no Service Worker.
 *
 * Foco Android: Chrome dispara `sync` events QUANDO O APP ESTÁ FECHADO se
 * o PWA está instalado e tem rede. O Workbox `BackgroundSyncPlugin` enfileira
 * a request original e re-faz quando o evento dispara. Ver service-worker.ts.
 *
 * iOS Safari: API ausente — `registration.sync` é undefined. Função vira no-op
 * sem erro. Foreground sync engine cobre o caso (foregroundSync.ts).
 *
 * Tags devem casar com as definidas em `src/sw/service-worker.ts`:
 *   - `outbox-data`   → POST /api/sync/producao + /api/sync/carreteiro
 *   - `outbox-photos` → POST /api/sync/fotos
 */

export type SyncTag = 'outbox-data' | 'outbox-photos'

export async function requestBgSync(tag: SyncTag): Promise<void> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return
  try {
    const reg = await navigator.serviceWorker.ready
    // `sync` é Background Sync API — não está no lib.dom.d.ts uniforme entre TS versions.
    const sync = (reg as unknown as { sync?: { register(tag: string): Promise<void> } }).sync
    if (sync) await sync.register(tag)
  } catch {
    // Sem suporte ou falha de registro — foreground sync cobre o caso
  }
}
